import { render, staticRenderFns } from "./EditLiveTheme.vue?vue&type=template&id=2016b35c"
import script from "./EditLiveTheme.vue?vue&type=script&lang=js"
export * from "./EditLiveTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports